
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { each } from 'lodash';

import { settings } from '../../app.settings';
import { Reward } from '../../shared/models/reward';
import { BaseService } from '~common/app/shared/services/base.service';
import { dateRange } from '~common/app/shared/utils/api';
import { NaiveParameterCodec } from '~common/app/shared/utils/encoding';

const API_PATH_GIFT = settings.api.url + '/rewards/gifts';
const API_PATH_CASHBACK = settings.api.url + '/rewards/cashbacks';

@Injectable()
export class RewardService extends BaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  private getPath(type) {
    return type === 'gifts' ? API_PATH_GIFT : API_PATH_CASHBACK;
  }

  fetch(type: string, params = {}): Observable<any> {
    const apiParams = this.proceedFilterParams(params);

    return this.http.get(this.getPath(type), {
      params: apiParams
    }).pipe(
      map((response) => {
        return this.hydrate(Reward, response);
      })
    );
  }

  fetchCounters(type: string): Observable<any> {

    return this.http.get(this.getPath(type) + '/metrics/status');
  }

  get(type: string, id: string): Observable<any > {
    return this.http.get(this.getPath(type) + '/' + id).pipe(
      map(response => {
        return this.hydrate(Reward, response);
      })
    );
  }

  getTimeline(type, id: string): Observable<any> {
    return this.http.get(this.getPath(type) + '/' + id + '/timeline');
  }

  upload(file: File, params = {}) {
    const formData = new FormData();
    formData.append('file', file);

    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });

    return this.http.post(API_PATH_GIFT + '/import', formData);
  }

  private proceedFilterParams(params = {}) {
    let apiParams = new HttpParams({ encoder: new NaiveParameterCodec() });

    each(params, (value: any, key) => {
      if (key === 'filters') {
        if (value.term) {
          apiParams = apiParams.append('keyword', value.term );
        }

        if (value.start_date || value.end_date) {
          apiParams = apiParams.append('created_at', dateRange(value.start_date, value.end_date));
        }
      } else if (value || value === 0 || value === false) {
        apiParams = apiParams.append(key, value);
      }
    });

    return apiParams;
  }
}
